// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","fullHeight":"Loader_fullHeight__0mUY7","rotate":"Loader_rotate__NEbL0","heading":"Loader_heading__ITgxq"};